import httpRequest from 'httpRequest'
import { CurrencyContract } from 'models'

const CURRENCY_PREFIX = '/currencies'

export const repository = {
    getCurrencies: () => {
        return httpRequest.get<CurrencyContract[]>(CURRENCY_PREFIX)
    },
}
